import {OfferType} from "../../../offer/types/OfferType";
import {ISearchFilterSlot} from "../../types/ISearchFilters";
import {SearchFilterTypes} from "../../types/SearchFilterTypes";

export const propertyType: ISearchFilterSlot<"type", OfferType[]> = {
    id: "type",
    label: "Typ nieruchomości",
    filters: [
        {
            id: "type",
            type: SearchFilterTypes.OFFER_TYPE,
            filterOptions: []
        }
    ]
};
import {OfferType} from "../../../offer/types/OfferType";
import {ISearchFilterSlot} from "../../types/ISearchFilters";
import {SearchFilterTypes} from "../../types/SearchFilterTypes";

export const propertyType: ISearchFilterSlot<"type", OfferType[]> = {
    id: "type",
    label: "Typ nieruchomości",
    filters: [
        {
            id: "type",
            type: SearchFilterTypes.OFFER_TYPE,
            filterOptions: []
        }
    ]
};
